import React, { useEffect, useState } from "react";
import BurgerMenuTitle from "../../Component/BurgerMenuTitle/BurgerMenuTitle";
import Style from "./UserInformation.module.css";
import Input from "../../Component/Input/Input";
import Button from "../../Component/Button/Button";
import { useForm } from "react-hook-form";
import { getUserInfo, UpdateUserInfo } from "../../Api/ClientServices";
import { errorToast, succToast } from "../../Toast/Toast";

const UserInformation = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const onSubmitHandler = () => {};

  useEffect(() => {
    getUserInformation();
  }, []);
  const [disabel, setDisable] = useState(false);
  const [name, setName] = useState("");
  const [lastname, setLastName] = useState("");
  const [email, setEmail] = useState("");

  const getUserInformation = async () => {
    getUserInfo((succ,res)=>{
      if(succ){
        if(res.status===0){
          errorToast("مشکلی پیش آمده است")
        }else{
          setName(res.info.first_name);
          setLastName(res.info.last_name);
          setEmail(res.info.email);
        }
      }else{
        console.error(res)
      }
    })
  };

  const updateHandle = () => {
    setDisable(true);
    const userInfo = {
      first_name: name,
      last_name: lastname,
      email: email,
    };
    UpdateUserInfo(userInfo, (succ, res) => {
      if (!succ) {
        errorToast("مشکلی پیش آمده")
        setDisable(false)
      } else {
        succToast("با موفقیت آپدیت شد")
        setDisable(false)
      }
    })
  }

  return (
    <form onSubmit={handleSubmit(onSubmitHandler)} className={Style.PageHolder}>
      <BurgerMenuTitle title={"نمایش اطلاعات کاربری"} />
      <section className={Style.InputHolder}>
        <h4>اطلاعات کاربری</h4>
        <span className={Style.firstSpan}> نام</span>
        <Input
          value={name}
          {...register("name", { required: false })}
          type={"text"}
          inputtype={errors.name ? "valid" : "UnderLine"}
          onChange={(e) => setName(e.target.value)}
        />
        <span> نام خانوادگی</span>
        <Input
          value={lastname}
          {...register("lastname", { required: false })}
          type={"text"}
          inputtype={errors.lastname ? "valid" : "UnderLine"}
          onChange={(e) => setLastName(e.target.value)}
        />
        <span> ایمیل</span>
        <Input
          value={email}
          {...register("email", { required: false })}
          inputtype={errors.email ? "valid" : "UnderLine"}
          type={"mail"}
          onChange={(e) => setEmail(e.target.value)}
        />
      </section>
      <Button
        Value={"ثبت تغییرات"}
        ClassBtn={"confrimBtn"}
        ClickHandler={updateHandle}
        disabledprops={disabel}
      />
    </form>
  );
};
export default UserInformation;
